export default "__VITE_ASSET__BVfgjqt$__"